var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-config-provider", { attrs: { locale: _vm.locale } }, [
    _c(
      "div",
      { staticClass: "overflow-hidden", attrs: { id: "app" } },
      [
        _c("home-page-header", {
          attrs: { showMenu: !this.$route.path.includes("apply") },
        }),
        _c(
          "div",
          { staticClass: "flex flex-col" },
          [_c("router-view"), _c("home-page-footer")],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }